import { axiosInstance } from '@/shared/api/axiosInstance';

export const requestTrainingPlan = async (instanceId: number): Promise<{ request_id: number }> => {
    const response = await axiosInstance.post(`/training-requests?instance_id=${instanceId}`);
    return response.data;
};

export const getTrainingStatus = async (request_id: number) => {
    const response = await axiosInstance.get(`/training-requests/${request_id}`);
    return response.data;
};

export const getLatestTrainingPlan = async () => {
    const response = await axiosInstance.get('/training-requests/latest');
    return response.data;
};
